<div class="documentation-accordion content">
  <div class="card">
    <div class="documentation-accordion_title">{{'CORE_ACCORDION' | translate}}</div>
  </div>
  <div class="card">
    <div class="mb-5">
      <div class="bold mb-2">ACCORDION</div>
      <div>
        <p-accordion styleClass="si-accordion">
          <p-accordionTab [selected]="true">
            <ng-template pTemplate="header">
              <div class="d-flex">
                <div translate="Title"></div>
              </div>
            </ng-template>
            <div>
              Contenido del acordeón
            </div>
          </p-accordionTab>
        </p-accordion>
      </div>
    </div>
    <div class="mb-5">
      <div class="bold mb-2">ACCORDION CON ACCIONES</div>
      <div>
        <p-accordion styleClass="si-accordion_actions">
          <p-accordionTab [selected]="true">
            <ng-template pTemplate="header">
              <div class="d-flex align-items-center">
                <div translate="Title"></div>
                <i class="icon-infocircle ml-auto" (click)="onClickInfoIconAccordion($event)"></i>
              </div>
            </ng-template>
            <div>
              Contenido del acordeón
            </div>
          </p-accordionTab>
        </p-accordion>
      </div>
    </div>
    <div class="mb-5">
      <div class="bold mb-2">ACCORDION BÁSICO</div>
      <div>
        <p-accordion [multiple]="true" styleClass="si-accordion_basic">
          <p-accordionTab [selected]="true">
            <ng-template pTemplate="header">
              <div class="d-flex">
                <div translate="Ejemplo 1"></div>
              </div>
            </ng-template>
            <div>
              <p-accordion [multiple]="true" styleClass="si-accordion_basic">
                <p-accordionTab [selected]="true">
                  <ng-template pTemplate="header">
                    <div class="d-flex">
                      <div translate="Ejemplo 2"></div>
                    </div>
                  </ng-template>
                  <div>
                    Contenido del acordeón
                  </div>
                </p-accordionTab>
              </p-accordion>
            </div>
          </p-accordionTab>
          <p-accordionTab [selected]="false">
            <ng-template pTemplate="header">
              <div class="d-flex">
                <div translate="Ejemplo 5"></div>
              </div>
            </ng-template>
            <div>
              Contenido del acordeón
            </div>
          </p-accordionTab>
        </p-accordion>
      </div>
    </div>
  </div>
</div>
